// extracted by mini-css-extract-plugin
export default {"visually_hidden":"ActiveLabel_visually_hidden__ROuuX","label":"ActiveLabel_label__bhpOq","show":"ActiveLabel_show__iS7nb","active":"ActiveLabel_active__iTXCI"};